<template>
  <el-container class="content-wrap">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicFoldSearch :searchList='searchList' v-on:getSearchObj='getSearchObj' />
    </div>
    <!-- 平台表格 -->
    <el-main style="padding: 0;">
      <BaseTable v-if="$store.state.userPlatForm === 'platForm'"
        style="background-color: #fff; padding: 20px; margin: 0 17px" :data="tableData" :column="tabListL1Config"
        pagination :auto-scroll="true" :total="totalPage" :page.sync="searchParams.current"
        @selection-change="selectionChange" :limit.sync="searchParams.size" @pagination="getList">
      </BaseTable>
      <!-- 机构表格 -->
      <BaseTable v-if="$store.state.userPlatForm === 'organization'"
        style="background-color: #fff; padding: 20px; margin: 0 17px" :data="tableData" :column="tabListL2Config"
        pagination :auto-scroll="true" :total="totalPage" :page.sync="searchParams.current"
        @selection-change="selectionChange" :limit.sync="searchParams.size" @pagination="getList">
      </BaseTable>
    </el-main>
    <!-- 退款弹窗 -->
    <el-dialog title="退款" class="refundDialog" destroy-on-close :visible.sync="showRefund" :close-on-click-modal="false"
      width="30%" center>
      <el-form status-icon label-width="80px" ref="refundRef" :model="refund" :rules="refundRules" size="small">
        <el-form-item label="退款金额" prop="refundMoney">
          <el-input v-model="refund.refundMoney" placeholder="请输入退款金额"></el-input>
        </el-form-item>
        <el-form-item label="退款说明" prop="refundText">
          <el-input type="textarea" v-model="refund.refundText" placeholder="请输入退款说明"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button slot="reference" type="primary" size="small" @click="submitHandel">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗信息 -->

    <el-dialog title="订单详情" :visible.sync="drawerFlag" width="50%" center :close-on-click-modal="false">
      <div style="height: 75vh">
        <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
          <el-form label-position="left" label-width="100px" label-suffix="：" size="small">
            <div class="header">
              <p></p>
              <h1>商品信息</h1>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="订单编号">
                  <span>{{ orderDetails.orderInfoVO.orderNo }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="病人">
                  <span>{{ orderDetails.orderInfoVO.patientName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="医生团队">
                  <span>{{ orderDetails.orderInfoVO.doctorTeamName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="领衔医生">
                  <span>{{ orderDetails.orderInfoVO.doctorName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务确认">
                  <span>{{
                    orderDetails.wholeCourseVO.auditorDoctorName ? orderDetails.wholeCourseVO.auditorDoctorName : '--'
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="服务名称">
                  <span>{{
                    orderDetails.wholeCourseVO.patientSchemeName ? orderDetails.wholeCourseVO.patientSchemeName : '--'
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="确认时间">
                  <span>{{
                    orderDetails.wholeCourseVO.auditorDoctorTime ? orderDetails.wholeCourseVO.auditorDoctorTime : '--'
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="线下机构">
                  <span>{{ orderDetails.orderInfoVO.hospitalName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="互医机构">
                  <span>{{ orderDetails.orderInfoVO.platformName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="服务周期">
                  <span>{{ orderDetails.wholeCourseVO.period ? orderDetails.wholeCourseVO.period : '--' }}
                    {{ orderDetails.wholeCourseVO.periodType | periodType }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务单价">
                  <span>{{ orderDetails.orderInfoVO.specOriginalPrice | money }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="header">
              <p></p>
              <h1>支付信息</h1>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="实付金额">
                  <span>{{ orderDetails.orderInfoVO.specCurrentPrice | money }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="应付金额">
                  <span>{{ orderDetails.orderInfoVO.specCurrentPrice | money }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="支付方式">
                  <span
                    v-if="orderDetails.orderInfoVO.commodityType === 6 && orderDetails.orderInfoVO.specCurrentPrice === 0">商品赠送</span>
                  <span v-else>{{ orderDetails.orderPayVO.paymentMethid | filterPay }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="支付时间">
                  <span>{{ orderDetails.orderPayVO.payTime }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="优惠金额">
                  <span>{{ (orderDetails.orderInfoVO.specOriginalPrice - orderDetails.orderInfoVO.specCurrentPrice) | money
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商户订单号">
                  <span>{{ orderDetails.orderPayVO.transactionNo ? orderDetails.orderPayVO.transactionNo : '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="创建时间">
                  <span>{{ orderDetails.orderInfoVO.createTime }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务时间">
                  <span>{{ orderDetails.wholeCourseVO.startTime ? orderDetails.wholeCourseVO.startTime : '--' }} 至
                    {{ orderDetails.wholeCourseVO.stopTime ? orderDetails.wholeCourseVO.stopTime : '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="header">
              <p></p>
              <h1>退款信息</h1>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="退款人">
                  <span>{{ orderDetails.orderPayVO.createUserName ? orderDetails.orderPayVO.createUserName : '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="退款时间">
                  <span>{{ orderDetails.orderPayVO.refundTime ? orderDetails.orderPayVO.refundTime : '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="退款金额">
                  <span>{{ orderDetails.orderPayVO.refundMoney | money }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="退款说明">
                  <span>{{ orderDetails.orderPayVO.refundText ? orderDetails.orderPayVO.refundText : '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="订单创建人">
                  <span>{{ orderDetails.orderInfoVO.patientName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单付款人">
                  <span>{{ orderDetails.orderInfoVO.patientName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="结束时间">
                  <span>{{ orderDetails.wholeCourseVO.stopTime ? orderDetails.wholeCourseVO.stopTime : '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单状态">
                  <span>{{
                    orderDetails.orderPayVO.paymentState | payStatus
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="header">
              <p></p>
              <h1>组合订单-服务明细</h1>
            </div>
            <!-- 商品明细 -->
            <el-row>
              <el-col :span="12">
                <el-form-item label="组合订单编号">
                  <span>{{
                    orderDetails.orderPayVO.orderNo
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单总价">
                  <span>{{ orderDetails.orderInfoVO.amountPayable | money }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <BaseTable style="background-color: #fff; padding: 20px 0; margin: 0 17px"
              :data="orderDetails.orderGoodsDetails" :column="orderGoodsDetailsConfig">
            </BaseTable>
          </el-form>
        </el-scrollbar>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import OrderPayConfig from "./common/orderPayConfig";
import axios from "axios";
import qs from "qs";
import { plateFormOn } from "@/api/acc.js";
import { followingCooperateOrg } from "../treatment/api/index.js";
import {
  getOrderList,
  getOrderDetails,
  getServiceByType,
  reminder,
  prescriptionRefund
} from "./api/orderPay";
import { hospital } from "@/api/doctorTeam";
export default {
  mixins: [OrderPayConfig],
  data() {
    var checkMoney = (rule, value, callback) => {
      if (!value || value == 0) {
        return callback(new Error("金额不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value * 100)) {
          callback(new Error("请输入正确的金额"));
        } else {
          if (value > this.scopeItme.payAmount) {
            callback(new Error("退款金额不可大于实付金额"));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    return {
      breadList: [{ name: "订单管理" }, { name: "全病程订单" }],
      searchList: [
        {
          label: "病人姓名",
          value: 1,
          paramName: "patientName",
          inputType: "input",
          maxLength: 5
        },
        {
          label: "医生姓名",
          value: 2,
          paramName: "doctorName",
          inputType: "input",
          maxLength: 5
        },
        {
          label: "支付状态",
          value: 3,
          paramName: "paymentState",
          inputType: "select",
          optionData: []
        },
        {
          label: "服务类型",
          value: 4,
          paramName: "type",
          inputType: "select",
          optionData: [
            { label: "医生服务", value: 1 },
            { label: "疗管服务", value: 2 }
          ]
        },
        {
          label: "服务名称",
          value: 5,
          paramName: "serviceName",
          inputType: "input"
        },
        {
          label: "申请时间",
          value: 6,
          paramName: "timeRange",
          inputType: "datetimerange",
          isTime: true,
          paramstartTime: "startTime",
          paramEndTime: "endTime"
        },
        {
          label: "线下机构",
          value: 7,
          paramName: "hospitalId",
          inputType: "hospital",
          optionData: []
        },
        {
          label: "是否组合订单",
          paramName: "combination",
          value: 9,
          inputType: "select",
          optionData: [
            {
              label: "是",
              value: true,
              key: 1
            },
            {
              label: "否",
              value: false,
              key: 2
            }
          ]
        },
        {
          label: "订单编号",
          value: 8,
          paramName: "orderNo",
          inputType: "input"
        },
        {
          label: "合作机构",
          value: 10,
          paramName: "orgCode",
          inputType: "select",
          optionData: []
        },
        {
          label: "支付方式",
          value: 11,
          paramName: "paymentMethods",
          inputType: "paymentMethods",
          paramStartPay: "lowPayAmount",
          paramEndPay: "highPayAmount",
          optionData: [
            {
              label: "微信支付",
              value: 1
            },
            {
              label: "患者组织赠送",
              value: 7
            },
            {
              label: "无支付",
              value: 6
            },
            {
              label: "商品赠送",
              value: 9
            }
          ]
        }
      ],
      searchParams: {
        current: 1,
        size: 10,
        commodityType: "1"
      },
      scopeItme: "", //
      serviceTypeList: [],
      showRefund: false, //退款弹窗开关
      activeName: "", //标签页选中
      totalPage: 0,
      refund: {
        refundMoney: "", //退款金额
        refundText: "" //退款说明
      },
      refundRules: {
        refundMoney: [
          {
            validator: checkMoney,
            trigger: "blur",
            required: true
          }
        ],
        refundText: [
          {
            required: true,
            message: "请输入退款原因",
            trigger: "blur"
          }
        ]
      },
      tableData: [],
      drawerFlag: false,
      serveTypeList: [
        // { name: "全部", id: "" },
        { name: "医生服务", id: 1 },
        { name: "疗管服务", id: 2 }
      ],
      orderType: "", //1, "方案/全病程 2, "药品" 3, "问诊"
      orderDetails: {
        orderDrugDetailVO: {},
        doctorVO: {},
        orderInfoVO: {},
        orderInquiryDetailVO: {},
        orderPayVO: {},
        wholeCourseVO: {},
        elecPrescriptionVO: {}
      }, //订单详情
      popupActiveName: "first",
      orderGoodsDetailsConfig: [
        {
          label: "商品名称",
          align: "center",
          prop: "goodsName"
        },
        {
          label: "商品数量",
          align: "center",
          prop: "goodsCount"
        },
        {
          label: "商品订单号",
          align: "center",
          prop: "orderNo"
        },
        {
          label: "商品总价(元)",
          align: "center",
          prop: "priceSum"
        }
      ]
    };
  },
  created() {
    this.searchList[2].optionData = this.$defaultData.orderPayStatus;
    if (this.$store.state.userPlatForm === "organization") {
      this.searchParams.hospitalId = this.$store.state.hospitalId;
      this.searchList.splice(-1, 1);
    }
    this.init();
    this.getServiceByTypeHandel();
    console.log("this.$options.filters", this.$options.filters.money);
    // 获取合作机构数据
    this.getOrgData();
  },
  methods: {
    getOrgData() {
      followingCooperateOrg({ current: 1, size: 999 }).then(res => {
        this.searchList[9].optionData = res.data.records.map(item => {
          return {
            ...item,
            label: item.orgName,
            value: item.orgCode
          };
        });
      });
    },
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      if (this.searchParams.hospitalName) {
        delete this.searchParams.hospitalName;
      }
      if (this.$store.state.userPlatForm === "organization") {
        this.searchParams.hospitalId = this.$store.state.hospitalId;
      }
      this.init();
    },
    /**
     * @description: 退款按钮弹窗 提交
     * @param {*}
     * @return {*}
     */
    submitHandel() {
      this.$refs["refundRef"].validate(valid => {
        if (valid) {
          prescriptionRefund({
            ...this.refund,
            orderId: this.scopeItme.id,
            orderDetailId: this.scopeItme.detailId
          }).then(res => {
            if (res.code == 0) {
              this.$message.success(res.message);
              this.scopeItme = "";
              this.refund = this.$options.data().refund;
              this.showRefund = false;
              this.init();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },

    /**
     * @description: 当状态为待支付当时候才可以推送
     * @param {*}
     * @return {*}
     */
    reminderHandel(scope) {
      reminder({
        doctorName: scope.doctorName,
        orderId: scope.id, //	订单ID
        orderName: scope.drugName, //订单名称
        patientId: scope.patientId, //患者ID
        patientName: scope.patientName, //患者名字
        userId: scope.userId, //	用户ID
        amountPayable: scope.amountPayable, //订单应付金额
        hospitalId: scope.hospitalId,
        platformId: scope.platformId
      }).then(res => {
        if (res.code == 0) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * @description: 提交退款金额 退款金额不可大于该订单的实付金额
     * @param {*}
     * @return {*}
     */
    submitRefundHandel() { },
    /**
     * @description: 退款按钮
     * @param {*}
     * @return {*}
     */
    hometRefundHandel(scope) {
      this.showRefund = true;
      this.scopeItme = scope;
      this.refund.refundText = scope.refundText;
    },
    /**
     * @description: 根据类型获取问诊服务
     * @param {serviceType：1}
     * @return {*}
     */
    getServiceByTypeHandel() {
      getServiceByType({
        serviceType: 1
      }).then(res => {
        if (res.code == 0) {
          this.serviceTypeList = res.data;
        }
      });
    },
    hometHandel(scope, type) {
      this.orderType = scope.row.commodityType;
      if (type == "details") {
        getOrderDetails(scope.row.id).then(res => {
          if (res.code == 0) {
            this.orderDetails = res.data;
            this.orderDetails.orderInfoVO.platformName = scope.row.platformName;
            this.orderDetails.orderGoodsDetails =
              res.data.orderGoodsDetails &&
              res.data.orderGoodsDetails.map(item => {
                return {
                  ...item,
                  priceSum: item.goodsCount * item.specCurrentPrice
                };
              });
            this.drawerFlag = true;
          }
        });
      }
    },
    selectionChange() { },

    getList(e) {
      this.init();
    },
    init() {
      this.searchParams.wholeCourseId = this.$route.query.id || "";
      getOrderList(this.searchParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records.map(item => {
            return {
              ...item,
              speCurrentPrice:
                item.specCurrentPrice | this.$options.filters.money,
              discount:
                (item.specOriginalPrice - item.specCurrentPrice) |
                this.$options.filters.money
            };
          });
          this.totalPage = res.data.total;
        }
      });
    }
  },

  filters: {
    payStatus(key) {
      switch (key * 1) {
        case 1:
          return "待支付";
        case 2:
          return "已支付";
        case 3:
          return "已取消";
        case 4:
          return "已退款";
        case 7:
          return "已完成";
        case 8:
          return "待退款";
        default:
          return "未知";
      }
    },
    prescriptionVO(key) {
      switch (key * 1) {
        case 1:
          return "西药处方";
        case 2:
          return "中药处方";
        case 3:
          return "营养处方";
        case 4:
          return "运动处方";
        case 5:
          return "治疗处方";
        default:
          return "未知";
      }
    },
    periodType(key) {
      switch (key * 1) {
        case 1:
          return "天";
        case 2:
          return "月";
        case 3:
          return "周";
        case 4:
          return "季";
        case 5:
          return "年";
        default:
          return key;
      }
    },
    filterServiceCode(key) {
      switch (key * 1) {
        case 1:
          return "在线问诊";
        case 2:
          return "在线续方";
        case 3:
          return "在线随访";
        case 4:
          return "在线复诊";
        default:
          return "未知";
      }
    }
  }
};
</script>

<style>
.el-form-item__label {
  font-size: 12px !important;
}
</style>
<style lang="less" scoped>
@import "./order.less";
</style>
